import { ColoursObj, Typography } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useState } from 'react'
import SoftPauerLogo from '../../../common/softpauerLogo'
import i18n from '../../../i18n/i18next'
import { openBrowser } from '../../../utils'
import { NavigationView } from '../../layout/NavigationView'
import { PersonListExpander } from './personListExpander'

export const CreditsPage = () => {
    const [showSecrets, setShowSecrets] = useState(false)
    let counter = 0

    const secretPass = () => {
        if (counter < 10) {
            counter++
        } else {
            setShowSecrets(!showSecrets)
            counter = 0
        }
    }

    const footer = () => {
        return (
            <Stack alignItems="center" paddingBottom="24px">
                <div
                    onClick={() => {
                        openBrowser('https://eventr.softpauer.com/')
                    }}
                >
                    <Typography
                        variant="bodyRegularUnderlined"
                        color={ColoursObj.core.primary}
                    >
                        https://eventr.softpauer.com/
                    </Typography>
                </div>
            </Stack>
        )
    }

    return (
        <NavigationView
            navigationBarTitle={i18n.t('account.credits')}
            backButtonAction={() => {
                window.pushPath('/account/about')
            }}
            usePageTransition
            footer={footer()}
        >
            <Stack
                direction="column"
                alignItems="center"
                gap="16px"
                paddingTop="8px"
            >
                <SoftPauerLogo onClick={secretPass} />
                <PersonListExpander
                    header="Management and Administration"
                    nameList={[
                        'Otmar Szafnauer',
                        'Alex Powell',
                        'Michelle Powell',
                        'Rebecca Thomas',
                        'Steve Worland',
                    ]}
                    showSecret={showSecrets}
                />
                <PersonListExpander
                    header="Developers"
                    nameList={[
                        'Andrius Muraukas - The one above all',
                        'Fernando Tamayo - Late King',
                        'Matthew Worner - I am speed',
                        'Willem Cawley Gelling - The Riddler',
                        'Edward Wilson - Bradford Enthusiast',
                        'Judy Makaka - Code Wreaker',
                        'Jez Young - That VR Guy',
                        'Tahmid Azam - Miracle Child',
                        'Ellie Harris - CSS Specialist',
                        'Michael Schenk - Young Man',
                        'Taimur Hassan - The Guy',
                        'Sam Whiltshire',
                    ]}
                    showSecret={showSecrets}
                />
                <PersonListExpander
                    header="Design"
                    nameList={[
                        'Olivia Duff - Liv "Bar Fight" Duff',
                        'James Costin-Pratt - Mr Kensington',
                        'Caitlin Mbabgong - The Chef',
                        'Zain Sarwar - The Cook',
                        'Samuel Boik - The One Who Knows',
                    ]}
                    showSecret={showSecrets}
                />
            </Stack>
        </NavigationView>
    )
}
